const defaultFont = { size: 16, style: 'normal', family: 'Helvetica Neue' }

const plugin = (chart, font = {}) => {
    const ctx = chart.ctx
    const selectedFont = { ...defaultFont, ...font }

    chart.data.datasets.forEach((dataset, i) => {
        const meta = chart.getDatasetMeta(i)
        const hidden = (meta.hidden === null) ? chart.data.datasets[i].hidden : meta.hidden;
        if (!hidden) {
            meta.data.forEach((element, index) => {
                ctx.fillStyle = dataset.borderColor
                ctx.font = `${selectedFont.style} ${selectedFont.size}px ${selectedFont.family}`
                ctx.textAlign = 'center'
                ctx.textBaseline = 'middle'

                const dataString = (dataset.data[index].metadata || {}).label
                if (dataString) {
                    const padding = 5
                    const position = element.tooltipPosition()
                    ctx.fillText(dataString, position.x, position.y - selectedFont.size / 2 - padding)
                }
            })
        }
    })
}

export default plugin



// WEBPACK FOOTER //
// ./App/components/modules/chart-plugins/drawPointLabel.js